export { default } from "./src/customer-gallery";

export type { UniformCustomerGalleryProps } from "./src/customer-gallery";
